import { FC, useMemo } from 'react';

import { MassMessageSpace } from 'models';

import keyBy from 'lodash/keyBy';
import has from 'lodash/has';

import SpaceItem from '../space-item';

import { useStyles as useCommonStyles } from '../style';

interface SpacesListProps {
  disabled: boolean;
  selectedSpaces: MassMessageSpace[];
  spaces: MassMessageSpace[];
  onSelectSpaces?: (spaces: MassMessageSpace[], checked: boolean) => void;
}

const SpacesList: FC<SpacesListProps> = ({
  disabled,
  selectedSpaces,
  onSelectSpaces,
  spaces,
}) => {
  const commonClasses = useCommonStyles();

  // convert array into hash table
  // in order to decrease iteration
  // over array for finding selected space
  const selectedSpacesDict = useMemo(
    () => keyBy(selectedSpaces, 'Id'),
    [selectedSpaces]
  );

  return (
    <ul className={commonClasses.ul}>
      {spaces.map((space) => {
        const isSelected = has(selectedSpacesDict, space.Id);

        return (
          <SpaceItem
            key={space.Id}
            onSelectSpace={onSelectSpaces}
            selected={isSelected}
            space={space}
            disabled={disabled}
          />
        );
      })}
    </ul>
  );
};

export default SpacesList;
